import { render, staticRenderFns } from "./HaulerSidebar.vue?vue&type=template&id=6020673b&scoped=true&"
import script from "./HaulerSidebar.vue?vue&type=script&lang=js&"
export * from "./HaulerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HaulerSidebar.vue?vue&type=style&index=0&id=6020673b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6020673b",
  null
  
)

export default component.exports